import {
  QueryClient,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query'
import { ErrorResponse } from './http-client'

// Utility types that default to ErrorResponse for the error type
export type MutationOptions<TData, TVariables> = UseMutationOptions<
  TData,
  ErrorResponse,
  TVariables
>

export type QueryOptions<TData> = UseQueryOptions<TData, ErrorResponse>

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})
